import { VisuallyHidden } from '@reach/visually-hidden';

export default VisuallyHidden;
